export const DEVICE = {
  PRIMARY: 'Primary',
  SECONDARY: 'Secondary',
};

export const EXCEPTION_TYPES = {
  PREMIUM: 'Premium',
  STANDARD: 'Standard',
  RECOMMENDED: 'RECOMMENDED',
  NO_EXCEPTION_REQUIRED: 'NO_EXCEPTION_REQUIRED',
  EXCEPTION_REQUIRED: 'EXCEPTION_REQUIRED',
  NA: 'NA',
};

export const DEFAULT_MEASUREMENT = 'metric';